import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { AccountLedgerPDFApi, SearchAccountLedgerApi } from "./LedgerAction"
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { setHeading } from "../../../accounts/account.actions";
import { GetLevelFourDropDownApi } from "../LevelFour/LevelFourAction";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Select from 'react-select';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const LedgerSearch = (props) => {
    const [levelFourId, setLevelFourId] = useState("");
    const [levelFourName, setLevelFourName] = useState("");
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();


    function SearchLedger() {
        props.SearchAccountLedgerApi({
            startDate: !_.isEmpty(startDate) ? startDate : "",
            endDate: !_.isEmpty(endDate) ? endDate : "",
            levelFourId: levelFourId,
        },
            startDate,
            endDate,
            levelFourName,
        );
    }

    const ExportPDF = () => {
        props.AccountLedgerPDFApi({
            startDate: !_.isEmpty(startDate) ? startDate : "",
            endDate: !_.isEmpty(endDate) ? endDate : "",
            levelFourId: levelFourId,
        },
            startDate,
            endDate,
            levelFourName
        );
    }

    const handleChangeLevelFour = (selectedOption) => {
        setLevelFourId(selectedOption.value);
        setLevelFourName(selectedOption.label)
    };
    const levelFourList = props.levelFourDropDownList?.length ? props.levelFourDropDownList.map(x => ({
        value: x._id,
        label: `${x.allLevelKey} - ${x.levelFourName}`,
    })) : [];


    useEffect(() => {
        props.GetLevelFourDropDownApi();
        props.setHeading("Ledger");
    }, []);

    return (
        <>
            {props.isFetchingLevelFourDropDown ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Start Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>End Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>Select Account *</b></Form.Label>
                                <Select
                                    placeholder="Select Account"
                                    onChange={handleChangeLevelFour}
                                    options={levelFourList}
                                    isClearable
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv" style={{ marginTop: "35px" }}>
                        {levelFourId === "" ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled style={{ padding: '8px 49px 8px 49px' }}><b> SEARCH LEDGER </b></Button>
                        ) : (
                            <Link to="/accountsModule/LedgerDetails">
                                <Button variant="contained" endIcon={<SendIcon />} size="large" style={{ padding: '8px 49px 8px 49px' }} onClick={SearchLedger}><b>SEARCH LEDGER</b></Button>
                            </Link>
                        )}
                    </div>

                    <div className="sendDiv" style={{ marginTop: "0px" }}>
                        {levelFourId === "" ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled><b>GENERATE LEDGER PDF</b></Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => ExportPDF()}><b>GENERATE LEDGER PDF</b></Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetLevelFourDropDownApi: () => dispatch(GetLevelFourDropDownApi()),
        AccountLedgerPDFApi: (data, startDate, endDate, levelFourName) => dispatch(AccountLedgerPDFApi(data, startDate, endDate, levelFourName)),
        SearchAccountLedgerApi: (data, startDate, endDate, accountName) => dispatch(SearchAccountLedgerApi(data, startDate, endDate, accountName)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingLevelFourDropDown: state.LevelFourReducer.isFetchingLevelFourDropDown,
    levelFourDropDownList: state.LevelFourReducer.levelFourDropDownList,
});

export default connect(mapStateToProps, mapDispatchToProps)(LedgerSearch);